import React, { FunctionComponent, useEffect, useState } from 'react';
import { Typography, Container, Paper, CircularProgress } from '@material-ui/core';
import styles from './Common.module.scss';
import { useHistory } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useSelector } from 'react-redux';
import { loadStaticHtmlContent } from '../services/StaticHtmlContentService';

const FaqDetails: FunctionComponent<any> = () => {
    const history: any = useHistory();
    const handleBack = () => { history.push("/"); };

    const [faqHtml, setFaqHtml] = useState<string>('');
    // const [initialLoading, setInitialLoading] = useState<boolean>(true);  // initial load
    const [translating, setTranslating] = useState<boolean>(false);       // fading when language change
    const [loadError, setLoadError] = useState<string>('');
    const hasLoadedOnce = React.useRef<boolean>(false);

    const languageSelected: any = useSelector((state: any) => state.lang);

    useEffect(() => {
        let isMounted = true;
        setLoadError('');

        if (!hasLoadedOnce.current) {
            //initial load
            // setInitialLoading(true); 
        } else {
            setTranslating(true);      //fade content
        }

        loadStaticHtmlContent('faq', languageSelected)
            .then((html: string) => {
                if (!isMounted) return;
                setFaqHtml(html);
                hasLoadedOnce.current = true;
            })
            .catch((err: any) => {
                console.error('Error loading FAQ content:', err);
                if (isMounted) setLoadError('Unable to load FAQ content. Please ensure the language HTML files exist in the public/faq folder.');
            })
            .finally(() => {
                if (isMounted) {
                    // setInitialLoading(false);
                    setTranslating(false);
                }
            });

        return () => { isMounted = false; };
    }, [languageSelected]);

    return (
        <React.Fragment>
            <Container maxWidth={"xl"} className={styles.FaqDetailSection}>
                <Container>
                    <div className={styles.BackNav}>
                        <ArrowBackIosIcon />
                        <span onClick={handleBack} className={styles.messageBox}>Back</span>
                    </div>
                    <Paper>
                        {loadError ? (
                            <Typography className={styles.FaqAnswer} style={{ padding: '30px', color: '#d32f2f' }}>
                                {loadError}
                            </Typography>
                        ) 
                        // : initialLoading ? (
                        //     <div style={{ textAlign: 'center', padding: '40px' }}>
                        //         <CircularProgress />
                        //     </div>
                        // ) 
                        : (
                            <div
                                className={`${styles.FaqDocxContent} ${translating ? styles.docxFading : styles.docxVisible}`}
                                dangerouslySetInnerHTML={{ __html: faqHtml }}
                            />
                        )}
                    </Paper>
                </Container>
            </Container>
        </React.Fragment>
    );
};

export default FaqDetails;